import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { debounceTime, filter, finalize, switchMap, tap } from 'rxjs/operators';

import { UserService } from '@core/api/user.service';

import * as fromApp from '@store';
import { User } from '@shared/models';
import { DialogYesNoComponent } from "../dialog-yes-no/dialog-yes-no.component";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface DialogData {
  currentApplicant: User;
  siteName: string;
}

@Component({
  selector: 'fc-dialog-change-applicant',
  templateUrl: './dialog-change-applicant.component.html',
  styleUrls: ['./dialog-change-applicant.component.scss'],
  standalone: false
})
export class DialogChangeApplicantComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  changeApplicantForm: UntypedFormGroup;
  usersList: User[] = [];
  isLoading: boolean = false;
  selectedUser = new UntypedFormControl('');
  filteredUser: User;

  constructor(
    readonly store: Store<fromApp.AppState>,
    public dialogRef: MatDialogRef<DialogChangeApplicantComponent>,
    readonly userService: UserService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.changeApplicantForm = new UntypedFormGroup({
      newApplicant: this.selectedUser,
    });

    this.changeApplicantForm.controls.newApplicant.valueChanges.pipe(
        debounceTime(500),
        filter(value => value.length >= 2),
        tap(() => {
          this.usersList = [];
          this.isLoading = true;
        }),
        switchMap(value =>
          this.userService.getFilteredUsers(`?count=40&offset=0&sort=display_name(asc)&role=Landowner&filters=is_active(eq,1),display_name(contains,${value})`)
            .pipe(
              finalize(() => {
                this.isLoading = false;
              })
            )
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((data: {
        results: User[];
        total: number;
      }) => {
        if (data) {
          this.usersList = data.results;
        } else {
          this.usersList = [];
        }
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    const confirmDialogRef = this.dialog.open(DialogYesNoComponent, {
      panelClass: 'fc-confirm-applicant-dialog',
      data: {
        title: 'Change Applicant',
        line1: `Are you sure you want to change the applicant of site ${this.data.siteName} from ${this.data.currentApplicant.getDisplayName()} to ${this.filteredUser.getDisplayName()}?`,
        buttonTextYes: 'Yes, Confirm',
        buttonTextNo: 'No, Cancel',
      },
      autoFocus: false,
    });

    confirmDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close({ user: this.filteredUser });
      }
    });
  }

}
